const { initUserConsFunc } = require("./types/ip-gathering");
const { summaryEdit } = require("./types/summary-editing");
const { checkForTooltips } = require("./utils/check-tooltips");
const { fillAddressInput } = require("./utils/fill-address-input");
const { openOffersHandler } = require("./utils/offers-handle");
const { checkAttr } = require("./utils/input-complete-state");

function handleRakProcessUpdate() {
    function processUpdateFunctions() {
        console.log("processUpdated functions triggered");
        checkForTooltips();
        setTimeout(() => openOffersHandler(), 800);
        fillAddressInput();
        initUserConsFunc();
        summaryEdit();
        checkAttr();
    }

    document.addEventListener("processUpdated.skye", processUpdateFunctions, false);
}

handleRakProcessUpdate();